<template>
  <div class="flow-day-marker" ref="flow_block" @mousedown="onBgDragMouseDown('from', $event)">
    <!--dragTimeActive: {{ dragTimeActive }}
    item.from: {{ item.from }}
    this.timeFrom: {{ timeFrom}}
    value: <pre>{{ value }}</pre>
    <pre>draggablesListVirtualOffsets: {{ dayplan_virtual_offsets }}</pre>-->
    <div class="p-2 text-center">
      <div class="m-0" >
        <!--<img v-if="value.type === 'START_DAY'" src="@/assets/logo.png" alt="Goalpilot" style="height:25px" />-->
        {{ value.type === 'START_DAY' ? '🌞' : null }}
        {{ value.type === 'END_DAY' ? '🛏️' : null }}
        <!--{{ value.type === 'NEXT_DAY' ? '🌞' : null }}-->
        {{ value.title }} at
        <!--<TimeSelector
          size="mini"
          :value="from_string"
          placeholder="Start time"
          :timePickerOptions = "{
            start: '00:00',
            step:  '00:05',
            end:   '24:00'
          }"
          @save="onSaveTime($event)" />-->
        <span style="margin-right: 6px"> {{timeFrom * 1e3|shortTime}} {{ dateChangeString }}</span>
          <span v-if="dragTimeActive">{{ (this.timeFrom - this.item.from) >= 0 ? '+' : '' }} {{ (this.timeFrom - this.item.from)|hoursMinutes }} </span>
      </div>
    </div>
    <div v-if="showConnection" class="flow-block-string position-absolute"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from '@/moment-gp'
//import TimeSelector from "@/components/Elements/TimeSelectorInline";

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true },
    dragTimeActive: { // TODO: Vuex
      type: Boolean
    },
    dateString: { // TODO: Vuex
      type: String
    },
  },
  data: () => ({
    from_string: '06:00',
    item: {},
    y_drag_offset: 0,
    y_drag_offset_init: 0,
    y_drag_active: false,
    y_drag_box_height: 0,
  }),
  watch: {
    value: {
      handler(newValue) {
        this.from_string = moment.unix( newValue.from ).format('HH:mm') // HACK
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters("dayplanner", [
      "show_reduced_dayplan",
      'dayplan_virtual_offsets',
      'drag_target_date'
    ]),
    timeFrom() {
      if (this.dayplan_virtual_offsets && this.dayplan_virtual_offsets[this.value.type] && this.drag_target_date === this.dateString) {
        return this.value.from + this.dayplan_virtual_offsets[this.value.type].from
      } else {
        return this.value.from
      }
    },
    dateChangeString() {
      if (moment(this.timeFrom * 1000).format("YYMMDD") !== this.dateString) {
        return '(+1 day)'
      }
      return ''
    }
  },
  methods: {
    onSaveTime(value) {
      let fromTime = moment(value, 'HH:mm').unix()
      this.$emit( 'change-time', { selection: value.type, timeFrom: fromTime, timeTo:fromTime } )
    },
    onBgDragMove(e) {
      // TODO: Limit to start time + 5 min
      this.y_drag_offset = e.clientY - this.y_drag_offset_init;
      const f = 0.2; // Scale factor
      const steps = 5 * 60 // 5 Minute steps
      let offset = steps * f * this.y_drag_offset;

      this.$emit('drag-time', { selection: this.value.type, offset: offset })
      // Snap to grid: this.y_drag_offset = Math.round( this.y_drag_offset / 10 ) * 10;
    },
    onBgDragMouseDown(source, $event) {
      $event.preventDefault();
      this.y_drag_offset_init = $event.clientY + 0;
      this.y_drag_active = source;
      window.addEventListener('mouseup', this.onBgDragMouseUp, false);
      window.addEventListener('pointerup', this.onBgDragMouseUp, false);
      window.addEventListener('mousemove', this.onBgDragMove, true);

      let rect = this.$refs.flow_block.getClientRects();
      this.y_drag_box_height = rect[0].height;
      document.body.style.cursor = 'ns-resize';
      this.$emit('drag-time-active',  { value: true })

    },
    onBgDragMouseUp(source, $event) {
      window.removeEventListener('mouseup', this.onBgDragMouseUp, false);
      window.removeEventListener('pointerup', this.onBgDragMouseUp, false);
      window.removeEventListener('mousemove', this.onBgDragMove, true);
      if (this.timeFrom !== this.item.from || this.timeTo !== this.item.to) {
        this.$emit('change-time', { selection: this.value.type, timeFrom: this.timeFrom, timeTo: this.timeFrom })
      }
      this.y_drag_active = false;
      this.y_drag_offset_init = 0;
      // this.y_drag_offset = 0;
      document.body.style.cursor = 'default';
      this.$emit('drag-time-active', { value: false })
    },
  },
  components: {
    //TimeSelector,
  }
}
</script>

<style>
.flow-day-marker {
  position: relative;
  margin-bottom: 25px;
  cursor: ns-resize;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  background: white;
}
</style>
